var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"callboard"},[_c('div',_vm._l((_vm.callboardItems),function(item){return _c('span',{class:{ 'called': item.isCalled }},[_vm._v("\n            "+_vm._s(item.callWord)+"\n        ")])}))]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69061e5c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/game/implementations/uk/wordsearch/_components/callboard/callboard.html
// module id = null
// module chunks = 